import Image from "next/image";
import Trustly from "../../../../../assets/images/trustly.png";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { FlexRow } from "ui-kit/Layout/Flex";
import { useWebTranslation } from "translations";
import { Icon } from "ui-kit";
import Colors from "ui-kit/colors";

const TrustlySecure = () => {
  const { t } = useWebTranslation();

  return (
    <FlexRow justifyContent="center" alignItems="center">
      <Icon name="trustly-secure" size="M" color={Colors.grey400} />
      <Gutter size={1} horizontal />
      <Typography variant="body3" color="grey400">
        {t("payment_methods.trustly_secure")}
      </Typography>
      <Image src={Trustly} height={30} width={90} alt="Trustly" />
    </FlexRow>
  );
};

export default TrustlySecure;
